import { render, staticRenderFns } from "./copy-field.vue?vue&type=template&id=a2c7349c&scoped=true&"
import script from "./copy-field.vue?vue&type=script&lang=js&"
export * from "./copy-field.vue?vue&type=script&lang=js&"
import style0 from "./copy-field.vue?vue&type=style&index=0&id=a2c7349c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c7349c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2c7349c')) {
      api.createRecord('a2c7349c', component.options)
    } else {
      api.reload('a2c7349c', component.options)
    }
    module.hot.accept("./copy-field.vue?vue&type=template&id=a2c7349c&scoped=true&", function () {
      api.rerender('a2c7349c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/copy-field.vue"
export default component.exports